// extracted by mini-css-extract-plugin
export var badge = "_hd-2";
export var detailsPanel = "_hd-0";
export var resultRow = "_hd-1";